export enum DocumentDeliveryMethodEnum {
  PaperForm = 1,
  ElectronicForm = 2,
  Directly = 3
}
